export const BLACK = '#30323D';
export const WHITE = '#FFFFFF';
export const PALE = '#F7F0F9';
export const DARK_PALE = '#DACCDE';
export const BLUE = '#3887D6';
export const RED = '#FE5F55';
export const YELLOW = '#EFAC1A';
export const PURPLE = '#6622CC';
export const CYAN = '#23F0C7';
export const GREEN = '#1AC15D';
export const GRAY = '#95959B';
export const COLOR_SEQUENCE = [RED, GREEN, BLUE, YELLOW, CYAN, PURPLE, GRAY];